<template>
  <app-content class="h-panel">
    <div class="flex justify-between mx-16px pt-16px">
      <DropdownCustom ref="assetsParamsDropdown" button class="h-btn-primary" trigger="click" @click.stop="$refs.assetsParamsDropdown.show()">
        <div>{{ manba(params.start).format('YYYY年MM月') }}</div>
        <template #content>
          <Form style="padding: 10px">
            <FormItem class="!pb-5px" label="会计期间">
              <Select :datas="checkoutSelect" v-model="params.start" :deletable="false"/>
            </FormItem>
            <FormItem class="!pb-5px">
              <vxe-button status="primary" @click="loadList();" :loading="loading">确定</vxe-button>
              <vxe-button @click="this.$refs.assetsParamsDropdown.hide()">取消</vxe-button>
              <!-- <vxe-button @click="reset">重置</vxe-button> -->
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right flex items-center">
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
      </div>
    </div>
    <div class="h-panel-body">
      <!--  :tree-config="{transform: true, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true,reserve: true}" -->
      <!--                  是否可以手动展开子节点                                                      默认展开所有节点 reserve是保持节点展开，但是不好用 -->
      <div class="text-center mb-16px font-bold text-20px">{{ title }} 费用明细表</div>
      <vxe-table 
                 :tree-config="{transform: false, rowField: 'treeId', parentField: 'parentTreeId',expandAll: true}"
                 show-footer
                 :footer-method="calcTotal"
                 :loading="loading" ref="xTable" :data="dataList" border >
        <vxe-column title="科目编码" field="subjectCode" fixed="left" tree-node width="20%"></vxe-column>
        <vxe-column title="科目名称" field="subjectName" fixed="left" width="20%"></vxe-column>
        <vxe-column title="本月金额" field="month" align="right" :formatter="formatMonth" width="7.5%"/>
        <vxe-column title="本年金额" field="year" align="right" :formatter="formatYear" width="7.5%"/>
      </vxe-table>
    </div>
  </app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import {mapGetters, mapState} from "vuex";
import {clone} from "xe-utils";
import setting from "@/api/setting";

export default {
  name: "ProfitSubjectBalance",
  data() {
    return {
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
          /* 表尾单元格样式 */
          .vxe-table tfoot td {
            border: 1px solid #000;
            font-size: 12px;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>费用明细表</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>编制单位：${this.currentAccountSets.companyName}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = ``;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
      dataList:[],
      checkDataList: [],
      params: {
        start: null,
        end:null,
        accountStandard:null,
      },
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    title() {
			if (!this.params.start) {
				return '';
			}
			return manba(this.params.start).format("YYYY年MM期")
		},
  },
  watch: {

  },
  methods: {
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        ...this.tablePrint,
      });
    },
    exportData() {
      const utils = new BooUtil(this.$refs.xTable, '\n')
      accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
        downloadBlob(`${this.title}-费用明细表.xls`, data)
      })
    },
    calcTotal({columns, data}) {
      let formatter = new Intl.NumberFormat('en-US', {  
        minimumFractionDigits: 2,  
        maximumFractionDigits: 2,  
        style: 'decimal', // 或者使用'currency'并设置currency属性为'USD'等，但注意这会添加货币符号  
      });
      const row = [];
      columns.forEach(col => {
        if ('month' === col.property) {  
          let allAmountMonth = 0;
          this.dataList.forEach(item => {
            if(item.parentTreeId == 0 && item.balanceDirection == "借"){
              allAmountMonth += (item.debit - item.credit + Number(item.cfCredit));
            }else if(item.parentTreeId == 0 && item.balanceDirection == "贷"){
              allAmountMonth += (item.credit - item.debit + Number(item.cfDebit));
            }
          })
          row.push(col.property === "month" ? formatter.format(allAmountMonth) : "")
        }else if('year' === col.property){
          let allAmountyear = 0;
          this.dataList.forEach(item => {
            if(item.parentTreeId == 0 && item.balanceDirection == "借"){
              allAmountyear += (item.yearTotalDebit - item.yearTotalCredit + Number(item.yearTotalCfCredit));
            }else if(item.parentTreeId == 0 && item.balanceDirection == "贷"){
              allAmountyear += (item.yearTotalCredit - item.yearTotalDebit + Number(item.yearTotalCfDebit));
            }
          })
          row.push(col.property === "year" ? formatter.format(allAmountyear) : "")
        }else {
          row.push(col.property === "subjectName" ? '合计' : "")
        }
      })
      return [row];
    },
    formatMonth(row){
      let formatter = new Intl.NumberFormat('en-US', {  
        minimumFractionDigits: 2,  
        maximumFractionDigits: 2,  
        style: 'decimal', // 或者使用'currency'并设置currency属性为'USD'等，但注意这会添加货币符号  
      });  

      if(row.row.balanceDirection == "借"){
        let amount = (Number(row.row.debit) - Number(row.row.credit) + Number(row.row.cfCredit));
        return formatter.format(amount);  
      }else{
        let amount = ( Number(row.row.credit) - Number(row.row.debit) + Number(row.row.cfDebit));
        return formatter.format(amount);
      }
    },
    formatYear(row){
      let formatter = new Intl.NumberFormat('en-US', {  
        minimumFractionDigits: 2,  
        maximumFractionDigits: 2,  
        style: 'decimal', // 或者使用'currency'并设置currency属性为'USD'等，但注意这会添加货币符号  
      });  

      if(row.row.balanceDirection == "借"){
        let amount = (Number(row.row.yearTotalDebit) - Number(row.row.yearTotalCredit) + Number(row.row.yearTotalCfCredit));
        return formatter.format(amount);  
      }else{
        let amount = ( Number(row.row.yearTotalCredit) - Number(row.row.yearTotalDebit) + Number(row.row.yearTotalCfDebit));
        return formatter.format(amount);
      }
    },
    loadList(){
      this.$api.accountbook.loadProfitSubjectBalance({
          start:manba(this.params.start).startOf(manba.MONTH).format("YYYY-MM-DD"),
          end:manba(this.params.start).endOf(manba.MONTH).format("YYYY-MM-DD"),
          accountStandard:this.currentAccountSets.accountStandard
        }).then(({data}) => {
          this.dataList = data;
          this.$refs.assetsParamsDropdown.hide()
        }).finally(() => {
          this.loading = false;
        });
    }
    
  },
  created() {
    console.log(this.checkoutSelect,this.params)
    //this.params.start = this.checkoutSelect[0].key;
    this.params.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");//改成账期
    this.loadList();
  }
}
</script>

<style scoped lang="less">

</style>


<script setup>
import manba from 'manba'
</script>
